import { render } from "./HepaticsDataMaterial.vue?vue&type=template&id=5ee165f9"
import script from "./HepaticsDataMaterial.vue?vue&type=script&lang=js"
export * from "./HepaticsDataMaterial.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__